module.exports = __webpack_public_path__ + "img/gzdp.e296a0b8.png";